// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const QutoChatbotSection = registerClientReference(
    function() { throw new Error("Attempted to call QutoChatbotSection() from the server but QutoChatbotSection is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/quto-chatbot-section.tsx",
    "QutoChatbotSection",
);
